"use client";

import {createContext, useContext, useRef} from "react";
import type {ScriptDirection} from "@/utils/scriptVersioning/paths";

export const ScriptProposalReviewContext = createContext<{
   proposalId: string;
   scriptId: string;
   direction: ScriptDirection;
   conversationId: string;
   host: HTMLDivElement | null;
   setHost: (node: HTMLDivElement | null) => void;
   hasReview: boolean;
   setHasReview: (value: boolean) => void;
   finish: () => void;
} | null>(null);

export const useScriptProposalReview = () => useContext(ScriptProposalReviewContext);

const ScriptProposalNavigationContext = createContext<Set<string> | null>(null);

/** Shared across full chat, script review, and dock so closing review does not reopen it. */
export function ScriptProposalNavigationProvider({children}: {children: React.ReactNode}) {
   const opened = useRef(new Set<string>());
   return <ScriptProposalNavigationContext.Provider value={opened.current}>{children}</ScriptProposalNavigationContext.Provider>;
}

export const useScriptProposalNavigation = () => useContext(ScriptProposalNavigationContext);

/** The conversation shown beside a script page when the dock cannot hold it. */
export const ScriptProposalSideConversationContext = createContext<string | null>(null);
